<template>
  <span>
    <span v-if="icon">{{ icon }}</span>
    <span
      :class="{
        'ml-1': !!icon,
        'font-weight-bold': highlighted,
      }"
    >
      {{ title }}
    </span>
  </span>
</template>

<script>
// jw: we need to parse any leading emojis
const emojiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/;

export default {
  name: 'ProductsFoundersCardItemBody',
  props: {
    value: {
      type: String,
      required: true,
    },
    highlighted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    let title = this.value;

    const match = emojiRegex.exec(title);

    let icon = null;
    if (match?.index === 0) {
      [icon] = match;
      title = title.slice(icon.length).trim();
    }

    return { icon, title };
  },
};
</script>

<style scoped lang="scss">
  @import '~/styles/dorado/main'; // TODO -- Remove once auto imported

  span {
    color: $bolt;
    transition: 150ms color;
    cursor: pointer;

    &:hover {
      color: $deep-ocean;
      text-decoration: none;
    }
  }
</style>
